'use client';

import AppHeader from "@/ui/sections/common/header";
import { SimplePage } from "@/ui/controls/page";
import { LinkButton } from "@/ui/controls/buttons";
import { SERVICES } from "@/fe/services";
import { DefaultAppLink } from "./default-app-link";

export default function NotFoundPage() {
  const { CTX }        = SERVICES();
  const currentUser    = CTX.useCurrentUser();
  const { currentApp } = CTX.useCurrentApp();

  return (
    <>
      <AppHeader />
      <SimplePage>
        <div className="flex flex-col items-center justify-center pt-[25%]">
          <h1 className="text-2xl mb-4">Sorry, what you&apos;re looking for does not exist.</h1>
          <p className="text-sm pb-2">The web address seems incorrect or broken. Please check it.</p>
          {currentUser && <DefaultAppLink currentUser={currentUser} currentApp={currentApp} />}
          <p className="text-sm">If needed, please contact <LinkButton url={"mailto:help@bostonbeer.com?subject=Claims%20Help"}>help@bostonbeer.com</LinkButton> for assistance.</p>
        </div>
      </SimplePage>
    </>
  );
}
